'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = require('mobx');

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _mux = require('./utils/mux');

var _mux2 = _interopRequireDefault(_mux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var state = (0, _mobx.observable)({});
  var actions = {};
  var hasPromises = false;

  (0, _forOwn2.default)(stores, function (store, key) {
    var storeActions = store(state, initialData, key);

    if (storeActions && typeof storeActions.then === 'function') {
      hasPromises = true;
    }

    actions[key] = storeActions;
  });

  if (hasPromises) {
    return (0, _mux2.default)(actions).then(function (resolvedActions) {
      return { state: state, actions: resolvedActions };
    });
  }

  return { state: state, actions: actions };
};